import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist({
  key: 'inventory-persistence',
  storage: localStorage,
});

export const inventoryListFilter = atom({
  key: 'inventoryListFilter',
  default: {
    category: [],
    subCategory: [],
    subSubCategory: [],
    vendors: [],
    brands: [],
    search: "",
    filter: "all",
    minPrice: 0,
    maxPrice: 99999,
  },
  effects_UNSTABLE: [persistAtom],
});

export const inventoryPaginationState = atom({
  key: 'inventoryPaginationState',
  default: {
    page: 1,
    limit: 10,
    pageactive: 1,
    limitactive: 10,
    pageinactive: 1,
    limitinactive: 10,
  },
  effects_UNSTABLE: [persistAtom],
});